export enum LogicalKeys {
  Policies = 'policies',
  Requirement = 'requirement',
}
